export const createContext = function (defaultValue) {
    return defaultValue;
};
